import { Helmet } from 'react-helmet'

import styles from './RewardsPage.pcss'
import Tile from '~/components/Tile'
import { PageHeader } from '~/components/PageHeader'
import { BannerVesisHolders } from './BannersVesisHolder'
// import { BannerPol } from './BannerPol'

export default function ClaimRewardsPage() {
	return (
		<div className={styles.page}>
			<Helmet>
				<title>Rewards</title>
			</Helmet>
			<Tile>
				<Tile.Header>
					<PageHeader title="Rewards" />
				</Tile.Header>

				{/*<div className={styles.bannerListContainer}>*/}
				{/*	<BannerPol />*/}
				{/*</div>*/}

				<div className={styles.bannerListContainer}>
					<BannerVesisHolders />
				</div>
			</Tile>
		</div>
	)
}
